export const objectUtil = {
  get: (object, path) => {
    const properties = Array.isArray(path) ? path : path.split(".");
    return properties.reduce((carry, node) => carry?.[node], object);
  },

  isObject: (x) => x !== null && typeof x === "object" && !Array.isArray(x),
};
